const MEETINGS_TYPE = {
  BOARD_OF_DIRECTORS: 0,
  ADVISORY_BOARD: 1,
  ADVISORY_SERVICE: 2,
  TEAM: 3,
  BMC: 4
};

const MEETINGS_STATE = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  DECLINED: 'declined'
};

const MEETING_POINT_STATUSES = {
  PENDING: 'pending',
  DISCUSSED: 'discussed',
  OMITTED: 'omitted',
  CURRENT: 'current'
};

const MEETING_POINT_STATUSES_INTEGER = {
  pending: 0,
  discussed: 1,
  omitted: 2,
  current: 3
};

export {
  MEETINGS_TYPE,
  MEETINGS_STATE,
  MEETING_POINT_STATUSES,
  MEETING_POINT_STATUSES_INTEGER
};
